import Axios from 'axios';
import api from '../axios/api';
import { IFile } from '../UI/FileList';

const processUpload = async (uploadedFile: IFile, updateFile: CallableFunction, setUploadSubmitError: CallableFunction) => {

  try {
    
    const signUrlRes = await api.post("files/signurl", { file: uploadedFile });
    await Axios.put(signUrlRes.data.url, uploadedFile.file, {
      onUploadProgress: e => {
        const progress = Number(Math.round((e.loaded * 100) / e.total));
        updateFile(uploadedFile.id, {
          progress
        });
      },
      headers: { 'Content-Type': signUrlRes.data.contentType }
    });
    
    const body = {
      name: uploadedFile.file.name,
      size: uploadedFile.file.size,
      key: `files/${signUrlRes.data.fileName}`,
      mimetype: signUrlRes.data.contentType,
      source: 'web',
    };
    
    const response = await api.post("files", body);
    setUploadSubmitError(false);
    updateFile(uploadedFile.id, {
      isNotUploaded: false,
      id: response.data._id,
      url: response.data.url,
      loading: false,
      error: false,
    });
    return response.data._id
  } catch (e) {
    updateFile(uploadedFile.id, {
      error: true,
      loading: false,
    });
  }
}
export default processUpload;